var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D9DBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9506 34.3802C33.3783 33.5669 30.7849 32.5 28 32.5C25.2151 32.5 22.6217 33.5669 21.0494 34.3802C20.0343 34.9052 19.423 35.9351 19.2883 37.07L19 39.5H37L36.7117 37.07C36.577 35.9351 35.9657 34.9052 34.9506 34.3802Z",
    fill: "#A0A3BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 29C30.4853 29 32.5 26.9853 32.5 24.5C32.5 22.0147 30.4853 20 28 20C25.5147 20 23.5 22.0147 23.5 24.5C23.5 26.9853 25.5147 29 28 29Z",
    fill: "#A0A3BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d29abde96a9e44a52509032b8ddec23c.svg";
export { ForwardRef as ReactComponent };